import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from 'v5/platform/dom/cn';

const enterpriseWorkspaceIconVariants = cva(
  'rounded-sm overflow-hidden flex items-center justify-center shrink-0 font-semibold leading-none text-fg-muted',
  {
    variants: {
      size: {
        sm: 'size-3.5 text-[8px]',
        md: 'size-6 text-[10px]'
      }
    },
    defaultVariants: {
      size: 'md'
    }
  }
);

export type EnterpriseWorkspaceIconProps = {
  name: string;
  iconUrl: string;
  size?: VariantProps<typeof enterpriseWorkspaceIconVariants>['size'];
  className?: string;
};

export function EnterpriseWorkspaceIcon({
  name,
  iconUrl,
  size = 'md',
  className
}: EnterpriseWorkspaceIconProps) {
  const initials = name.substring(0, 2).toUpperCase();

  return (
    <div
      aria-hidden="true"
      className={cn(
        enterpriseWorkspaceIconVariants({ size }),
        !iconUrl && 'bg-bg-subtle',
        className
      )}
    >
      {iconUrl ? (
        <img
          src={iconUrl}
          alt=""
          className="size-full object-cover rounded-sm"
        />
      ) : (
        <span className="select-none">{initials}</span>
      )}
    </div>
  );
}
